import { useEffect, useState } from 'react';
import { readFeatureFlagFromDocumentCookie } from '../utils/feature-flags/read-feature-flag';

/**
 * Reads a backoffice-managed feature-flag cookie (see utils/feature-flags/). Starts at
 * `defaultValue` (or `initialValue` when the caller already read the cookie server-side, e.g.
 * from pageContext, see navbar-live-index-flag.ts's Phase 1 review fix 2.8) to match SSR, then
 * re-reads the real cookie value post-hydrate, so there's no SSR/client markup mismatch and no
 * flash of the flagged experience for opted-out (or, with `initialValue`, opted-in) users.
 */
export function useFeatureFlag(cookieName: string, defaultValue = false, initialValue?: boolean): boolean {
  const [enabled, setEnabled] = useState(initialValue ?? defaultValue);
  useEffect(() => {
    setEnabled(readFeatureFlagFromDocumentCookie(cookieName, defaultValue));
    // Deliberately only re-reads on mount / cookieName change, not on every render, a flag
    // toggled in another tab needs a reload to take effect, same as every other flag here.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cookieName]);
  return enabled;
}
